var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAntenna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1560_9522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.11719 24.8976L14.552 4.02808M14.552 24.8976L24.9868 4.02808M24.9868 24.8976L35.4215 4.02808M35.4215 24.8976L45.8563 4.02808M9.33458 14.4629H40.6389M24.9868 33.2455V45.7672",
    stroke: "url(#paint0_linear_1560_9522)",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1560_9522",
    x1: 24.9868,
    y1: 4.02808,
    x2: 24.9868,
    y2: 45.7672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1560_9522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.988281 0.897705)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntenna);
export default __webpack_public_path__ + "static/media/Antenna.c2c2431a1cf7119df180a3b48c5685ba.svg";
export { ForwardRef as ReactComponent };